/* Presentational native element shared by the independently rendered VV247 apps. */
(() => {
  'use strict';
  if (customElements.get('vv247-journey-preview')) return;
  class JourneyPreview extends HTMLElement {
    static observedAttributes = ['from', 'to', 'miles', 'amount-pence', 'price-label'];
    connectedCallback() { this.schedule(); }
    disconnectedCallback() { this.observer?.disconnect(); }
    attributeChangedCallback() { this.schedule(); }
    schedule() {
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => { this.queued = false; if (this.isConnected) this.render(); });
    }
    render() {
      const from = this.getAttribute('from'), to = this.getAttribute('to');
      const rawMiles = this.getAttribute('miles'), miles = Number(rawMiles);
      if (!from || !to || rawMiles === null || !Number.isFinite(miles) || miles < 0) { this.hidden = true; return; }
      const signature = JourneyPreview.observedAttributes.map(k => this.getAttribute(k)).join('|');
      if (this.signature === signature && this.childNodes.length) { this.hidden = false; return; }
      const template = document.getElementById('vv247-journey-template');
      if (!(template instanceof HTMLTemplateElement)) return;
      this.observer?.disconnect();
      this.replaceChildren(template.content.cloneNode(true));
      const postcode = s => /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/i.test(s.replace(/\s/g, '')) ? s.replace(/\s/g, '').toUpperCase().replace(/(.+)(.{3})$/, '$1 $2') : s;
      this.querySelector('[data-journey-from]').textContent = postcode(from);
      this.querySelector('[data-journey-to]').textContent = postcode(to);
      this.querySelector('[data-journey-miles]').textContent = new Intl.NumberFormat('en-GB', {maximumFractionDigits:1}).format(miles);
      const rawPrice = this.getAttribute('amount-pence'), price = Number(rawPrice);
      this.querySelector('[data-journey-price-box]').hidden = rawPrice === null || !Number.isFinite(price) || price < 0;
      this.querySelector('[data-journey-price]').textContent = new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',maximumFractionDigits:price % 100 ? 2 : 0}).format(price / 100);
      if (this.getAttribute('price-label')) this.querySelector('[data-journey-price-label]').textContent = this.getAttribute('price-label');
      this.hidden = false; this.signature = signature;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { this.querySelector('.vj-preview')?.classList.add('vj-animate'); this.observer.disconnect(); }
        }, {threshold:0.2});
        this.observer.observe(this);
      } else this.querySelector('.vj-preview').classList.add('vj-animate');
    }
  }
  customElements.define('vv247-journey-preview', JourneyPreview);
})();
